// Composer 输入框高度计算配置
export const COMPOSER_INPUT_CONFIG = {
  LINE_HEIGHT: 20,
  PADDING_TOP: 6,
  PADDING_BOTTOM: 6,
  BORDER_WIDTH: 1,
  MAX_LINES: 7,
  TOOLBAR_PADDING: 10,
  get MIN_HEIGHT() {
    return this.LINE_HEIGHT + this.PADDING_TOP + this.PADDING_BOTTOM + this.BORDER_WIDTH * 2; // 34px
  },
  get MAX_HEIGHT() {
    return this.LINE_HEIGHT * this.MAX_LINES + this.PADDING_TOP + this.PADDING_BOTTOM + this.BORDER_WIDTH * 2; // 134px for 6 lines
  }
};

export const LABEL_HEIGHT = 5;
// 单行文本高度：输入框MIN_HEIGHT + 容器padding = 44px
export const MIN_COMPOSER_HEIGHT = COMPOSER_INPUT_CONFIG.MIN_HEIGHT + COMPOSER_INPUT_CONFIG.TOOLBAR_PADDING;
// 最大文本高度：输入框MAX_HEIGHT + 容器padding，自动跟随MAX_LINES变化
export const MAX_COMPOSER_HEIGHT = COMPOSER_INPUT_CONFIG.MAX_HEIGHT + COMPOSER_INPUT_CONFIG.TOOLBAR_PADDING;
export const DEFAULT_PLACEHOLDER = 'Type a message...';
export const DATE_FORMAT = 'll';
export const TIME_FORMAT = 'LT';
